import React, { useRef } from 'react';

const VideoPlayer = ({ film , onVideoEnd }) => {
  const videoRef = useRef(null);
  
  const handleVideoEnd = () => {
    if (onVideoEnd) {
      onVideoEnd(); // Gọi hàm playNextVideo được truyền từ FilmGrid
    }
  };

  if (!film) {
    return (
      <div className="w-full aspect-video bg-gray-800 rounded-lg flex items-center justify-center mb-8">
        <p className="text-gray-400">Vui lòng chọn một bộ phim để xem</p>
      </div>
    );
  }
  return (
    <div className="flex">
      <div className="bg-gray-800 p-5 rounded-lg mb-5 w-full">
        <h2 className='text-white pb-2.5'>{film.name}</h2>
        <video className="w-full rounded-lg" style={{minHeight: '300px', height:'500px'}} src={film.path} controls autoPlay={true} ref={videoRef}
      onEnded={handleVideoEnd}/>
      </div>
      
    </div>
  );
};

export default VideoPlayer;


